import FormField from "components/FormField";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import React, { useEffect, useState } from "react";
import { useAppServices } from "hook/services";
import toast from "react-hot-toast";

function SocialUrl({ formData, handleRefresh }) {
  const AppService = useAppServices();
  const [success, setsuccess] = useState("");
  const [currentFormData, setcurrentFormData] = useState({
    privacy: "",
    terms_condition: "",
    community: "",
    help_center: "",
    video_tutorial: "",
  });
  const [loadingButton, setLoadingButton] = useState(false);

  // Sync currentFormData with formData when formData changes
  useEffect(() => {
    if (formData) {
      setcurrentFormData(formData);
    }
  }, [formData]);

  // Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setcurrentFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setsuccess("");
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoadingButton(true);

    const payload = {
      _id: currentFormData.id,
      instagram: currentFormData.instagram,
      facebook: currentFormData.facebook,
      twitter: currentFormData.twitter,
      linked_in: currentFormData.linked_in,
      youtube: currentFormData.youtube,
      agency_id: currentFormData.agency_id,
    };
    const { response } = await AppService.accounts.update({ payload });
    if (response) {
      handleRefresh();
      setLoadingButton(false);
      toast.success("Data updated Successfully");
    } else {
      toast.error("Error updating Data");
      setLoadingButton(false);
    }
  };
  return (
    <div>
      <form onSubmit={handleSubmit}>
        <div style={{ display: "flex", width: "100%" }}>
          <div style={{ width: "50%", padding: "10px 10px 0px 10px" }}>
            <SoftBox style={{ margin: "10px 0px " }}>
              <label className="text-black">Facebook</label>
              <input
                className="form-control-agust"
                label="Facebook"
                onChange={handleChange}
                placeholder="Facebook"
                name="facebook"
                value={currentFormData.facebook}
              />
            </SoftBox>
            <SoftBox style={{ margin: "10px 0px " }}>
              <label className="text-black">Twitter</label>
              <input
                className="form-control-agust"
                onChange={handleChange}
                placeholder="Twitter"
                name="twitter"
                value={currentFormData.twitter}
              />
            </SoftBox>
          </div>
          <div style={{ width: "50%", padding: "10px 10px 0px 10px" }}>
            <SoftBox style={{ margin: "10px 0px " }}>
              <label className="text-black">Instagram</label>
              <input
                className="form-control-agust"
                onChange={handleChange}
                placeholder="Instagram"
                name="instagram"
                value={currentFormData.instagram}
              />
            </SoftBox>

            <SoftBox style={{ margin: "10px 0px " }}>
              <label className="text-black">LinkedIn</label>
              <input
                className="form-control-agust"
                onChange={handleChange}
                placeholder="LinkedIn"
                name="linked_in"
                value={currentFormData.linked_in}
              />
            </SoftBox>
          </div>
        </div>
        <div style={{ display: "flex", width: "100%" }}>
          <div style={{ width: "50%", padding: "10px 10px 0px 10px" }}>
            <SoftBox style={{ margin: "10px 0px " }}>
              <label className="text-black">Youtube</label>
              <input
                className="form-control-agust"
                onChange={handleChange}
                placeholder="Youtube"
                name="youtube"
                value={currentFormData.youtube}
              />
            </SoftBox>
          </div>
        </div>
        <div style={{ margin: "10px 0px", textAlign: "right" }}>
          <SoftButton
            disabled={loadingButton}
            type="submit"
            color="dark"
            className="px-2 py-1"
            style={{ background: "black", color: "white" }}
          >
            {loadingButton ? "Updating..." : "Update"}
          </SoftButton>
        </div>
      </form>
    </div>
  );
}

export default SocialUrl;
